<template>
  <div>
    <p v-if="message !== null">
      {{message}}
    </p>

    <loading-indicator
      v-if="isLoading"
    />

    <template v-if="individualSeasons !== null && individualSeasons.length > 0">
      <player-season
        v-for="season in individualSeasons"
        :key="season.id"
        :season="season"
        class="mb-3"
      />
    </template>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { getSeasonStatusName } from '../model/season.js';

import PlayerSeason from './PlayerSeason.vue';
import LoadingIndicator from './LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'PlayerIndividualSeasons',

  components: {
    PlayerSeason,
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      /** @type {?Object[]} */
      individualSeasons: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(this.isLoadedNormal && this.individualSeasons !== null && this.individualSeasons.length === 0) {
        return 'This player has no individual seasons.';
      }
      return null;
    },
  },

  created() {
    this.loadIndividualSeasons();
  },

  methods: {
    loadIndividualSeasons() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/player/${this.playerId}/individual_seasons`;
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        this.individualSeasons = data.seasons;

        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },

  filters: {
    getSeasonStatusName,
  },
}
</script>
